<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import BreadcrumbNav from '../BreadcrumbNav';

@Component()
export default class BreadcrumbNavConnected extends Vue {
  render (h) {
    return h(BreadcrumbNav, {
      props: {
        items: this.$store.state.webPanel.breadcrumbItems,
      },
    });
  }
}
</script>
